import { put, call } from 'redux-saga/effects'

import { BFFAgent } from '../../../../common/BFFAgent'
import {
  COMMISSIONS_UPDATE_COMMISSION_MONTH_SUCCESS,
  COMMISSIONS_UPDATE_COMMISSION_MONTH_FAILURE
} from '../constants'

export function* updateCommissionSaga(action) {
  try {
      yield call(BFFAgent.Commission.updateCommissionMonth, action.data.id, action.data)

      yield put({
          type: COMMISSIONS_UPDATE_COMMISSION_MONTH_SUCCESS
      })
      
  } catch (error) {
    yield put({
      type: COMMISSIONS_UPDATE_COMMISSION_MONTH_FAILURE,
      data: { error }
    })
  }
}
